import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
let langa = localStorage.getItem('i18n-lang') || 'en';
let lang = langa=='zh'?'cn':langa;

const routes = [
	{
		path: `/`,
		name:'Index',//首页
		component: () => import('@/views/index/index.vue'),
	},
	{
		path: `/${lang}`,
		name:'Index',//首页
		component: () => import('@/views/index/index.vue'),
	},
	{
		path: `/${lang}`+'/product',
		name:'product',//产品
		component: () => import('@/views/product/index.vue'),
	},
	{
		path: `/${lang}`+'/productDetail',
		name:'productDetail',//产品
		component: () => import('@/views/product/detail.vue'),
	},
	{
		path: `/${lang}`+'/innovation',
		name:'innovation',//创新平台
		component: () => import('@/views/innovation/index.vue'),
	},
	{
		path: `/${lang}`+'/innovationDetail',
		name:'innovationDetail',//创新详情
		component: () => import('@/views/innovation/detail.vue'),
	},
	{
		path: `/${lang}`+'/about',
		name:'about',//关于澳华
		component: () => import('@/views/about/index.vue'),
	},
	{
		path: `/${lang}`+'/abInvest',
		name:'abInvest',//投资关系
		component: () => import('@/views/about/invest.vue'),
	},
	{
		path: `/${lang}`+'/news',
		name:'news',//新闻
		component: () => import('@/views/news/index.vue'),
	},	
	{
		path: `/${lang}`+'/newsDetail',
		name:'newsDetail',//新闻详情
		component: () => import('@/views/news/detail.vue'),
	},	
	{
		path: `/${lang}`+'/recruit',
		name:'recruit',//招贤纳士
		component: () => import('@/views/recruit/index.vue'),
	},
	{
		path: `/${lang}`+'/recruitSociety',
		name:'recruitSociety',//招贤纳士 社会招聘
		component: () => import('@/views/recruit/society.vue'),
	},
	{
		path: `/${lang}`+'/recruitSocietyDetail',
		name:'recruitSocietyDetail',//招贤纳士 社会招聘
		component: () => import('@/views/recruit/societyDetail.vue'),
	},
	{
		path: `/${lang}`+'/putInSuc',
		name:'putInSuc',//投递成功
		component: () => import('@/views/recruit/putInSuc.vue'),
	},
	{
		path: `/${lang}`+'/recruitCampus',
		name:'recruitCampus',//校园招聘
		component: () => import('@/views/recruit/campus.vue'),
	},
	{
		path: `/${lang}`+'/recruitCampusDetail',
		name:'recruitCampusDetail',//实习生招聘
		component: () => import('@/views/recruit/campusDetail.vue'),
	},
	{
		path: `/${lang}`+'/contact',
		name:'contact',//联系我们
		component: () => import('@/views/contact/index.vue'),
	},	
	
	{
		path: '/null',
		name:'null',//网站建设中
		component: () => import('@/views/404.vue'),
	},
	{
		path: '/cs',
		name:'cs',//网站建设中
		component: () => import('@/views/cs.vue'),
	},
]

const router = new VueRouter({
	mode: "history",
	routes,
	scrollBehavior(to, from, savedPosition) {
	    // 期望滚动到哪个位置
	    return {
	      x: 0,
	      y: 0
	    }
	  },
})
router.beforeEach((to, from, next) => {
	console.log(to,from)
	if(to.path.includes('cn')){
		if(lang!=='cn'){
			lang = 'cn';
			let aa=lang=='cn'?'zh':lang=='en'?'en':'eu';
			localStorage.setItem("i18n-lang", aa);
			window.location.href='/cn';
			
			// next(`/`);
			// window.location.reload()
			return
		}
		
	}else if(to.path.includes('en')){
		if(lang!=='en'){
			lang = 'en';
			localStorage.setItem("i18n-lang", lang);
			window.location.href='/en';
			return
			// next(`/`);
			// window.location.reload()
			// return
		}
	}else if(to.path.includes('eu')){
		if(lang!=='eu'){
			lang = 'eu';
			localStorage.setItem("i18n-lang", lang);
			window.location.href='/eu';
			return
			// next(`/`);
			// window.location.reload()
			// return
		}
	}
	let path='';
	let pathTwo='';
	if(!to.path.includes(lang)){
		path=to.fullPath;
		if(path=="/"){
			pathTwo= `/`;
		}else{
			pathTwo= `/${lang}` + path;
		}
	}
	console.log(to.path.includes(lang));
  // 判断用户访问的路由是否存在
  if (to.matched.length === 0) {
    // 如果路由不存在，则跳转到指定页面
	if(!to.path.includes(lang)){
		console.log(pathTwo)
		next(pathTwo);
	}else{
		next('/null');
	}
  } else {
	// 让页面回到顶部
	// document.documentElement.scrollTop = 0
    // 路由存在，则继续访问该路由
    next();
  }
});
export default router
